module.exports = __webpack_public_path__ + "static/media/image_keyword_02.ec90067c.webp";